import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'customer'

const client = new ApiClient(API_NAME)

export default {
  show(accountId) {
    return client.get(`/${BASE_PATH}/${accountId}`)
  },
  update(accountId, data) {
    return client.put(`/${BASE_PATH}/${accountId}`, data)
  }
}
